<template>
  <Container v-if="getSelectedFilters.length">
    <ClearButton @click="handleClearClick">Clear</ClearButton>
    <FilterButton v-for="(item, key) in getSelectedFilters" :key="key" @click="handleFilterButtonClick(item, $event)">
      <ButtonLabel>{{ item }}</ButtonLabel>
      <ButtonValue>{{ getValue(item) }}</ButtonValue>
    </FilterButton>
  </Container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { propEq, pipe, filter, map, prop, sum, length, both } from 'ramda';

import { PREFIX as REGIONS_STORE } from '../../../modules/regions';
import {
  GET_DATA,
  GET_SELECTED_FILTERS,
  GET_SELECTED_SUBTOPIC,
  GET_YEAR_FILTER,
} from '../../../modules/regions/regions.getters';
import { CLEAR_SELECTED_FILTERS, TOGGLE_SELECTED_FILTER } from '../../../modules/regions/regions.mutations';
import { Container, FilterButton, ClearButton, ButtonLabel, ButtonValue } from './summaryBar.styles';
import { orderOfMagnitude } from '../../utils/formatNumbers';
import { getRegionField, getValueField, parseNumber } from '../../utils/helpers';
import { YEAR_FIELD } from '../../constants';

export default {
  components: { Container, FilterButton, ClearButton, ButtonLabel, ButtonValue },
  methods: {
    ...mapMutations(REGIONS_STORE, [CLEAR_SELECTED_FILTERS, TOGGLE_SELECTED_FILTER]),
    handleClearClick() {
      this[CLEAR_SELECTED_FILTERS]();
    },
    handleFilterButtonClick(region) {
      this[TOGGLE_SELECTED_FILTER](region);
    },
    getValue(region) {
      const regionField = getRegionField(this[GET_SELECTED_SUBTOPIC]);
      const year = this[GET_YEAR_FILTER];

      if (this.valueField) {
        return pipe(
          filter(both(propEq(regionField, region), propEq(YEAR_FIELD, year))),
          map(prop(this.valueField)),
          map(parseNumber),
          sum,
          orderOfMagnitude
        )(this[GET_DATA]);
      }

      return pipe(filter(propEq(regionField, region)), length)(this[GET_DATA]);
    },
  },
  computed: {
    ...mapGetters(REGIONS_STORE, [GET_SELECTED_FILTERS, GET_SELECTED_SUBTOPIC, GET_DATA, GET_YEAR_FILTER]),
    valueField: function() {
      return getValueField(this[GET_SELECTED_SUBTOPIC]);
    },
  },
};
</script>
